import React from 'react';
import DateRangeMenu, {
  NO_DATE_BOUNDS,
} from '../../../../shared/designSystem/components/DateRangeMenu';

// =============================================================================
// CampaignRangeSelector — shared page-level range picker shim used by
// Display / Sign Ups (V1+V2) / Sessions (V1+V2).
//
// Migrated from the segmented `<DateRangePicker>` (pills + Custom popover)
// to the modern single-trigger `<DateRangeMenu>` (one labelled pill →
// popover with presets-on-left + calendar-on-right + selected-dates row).
// 2024-25 dashboard convention (Linear / Stripe / GA4 / shadcn-DRP).
//
// API mirrors the prior shim — props pass through; consumer changes none.
// `disabled` is forwarded so consumers that previously gated the picker
// when there was no data can keep doing that. The `setRangeKey` helper
// some Summary-style consumers used is now folded into the consumer's
// own `setRangeType` handler (see SummaryRangeSelector for the pattern).
// =============================================================================
// `disabledDate` defaults to NO_DATE_BOUNDS — Campaign Details pickers carry no
// date bounds (#11685). `defaultDateRange` here is the campaign flight window,
// but every preset except "All Time" is relative to TODAY; on a campaign that
// already ended the two do not overlap, so DateRangeMenu's implicit clamp would
// disable every day "Last 7 Days" resolves to. Defaulting here rather than at
// each of the eight call sites means none of them can forget.
//
// Pass an explicit `disabledDate` to re-bound a specific picker.
const CampaignRangeSelector = ({
  rangeType,
  byCampaignRangeDate,
  setRangeType,
  setByCampaignRangeDate,
  timezone = 'UTC',
  defaultDateRange,
  disabledDate = NO_DATE_BOUNDS,
  disabled = false,
}) => {
  return (
    <DateRangeMenu
      rangeType={rangeType}
      onRangeTypeChange={setRangeType}
      value={byCampaignRangeDate}
      onChange={setByCampaignRangeDate}
      defaultDateRange={defaultDateRange}
      disabledDate={disabledDate}
      timezone={timezone}
      disabled={disabled}
    />
  );
};

export default CampaignRangeSelector;
